module.exports = __webpack_public_path__ + "assets/img/services1.3599d5a3.svg";